export function SkeletonLine({ width = '100%', height = '1rem', style }) {
  return (
    <div
      className="skeleton-line"
      style={{ width, height, ...style }}
    />
  );
}

// Shimmer line for use on dark (navy) app-header backgrounds
function SkeletonHeaderLine({ width, height = '0.85rem', style }) {
  return (
    <div
      className="skeleton-header-line"
      style={{ width, height, ...style }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-card-photo skeleton-line" />
      <div className="skeleton-card-body">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
          <SkeletonLine width="40%" height="0.65rem" />
          <SkeletonLine width="3rem" height="1.1rem" style={{ borderRadius: '999px' }} />
        </div>
        <SkeletonLine width="75%" height="1rem" style={{ marginBottom: '0.3rem' }} />
        <SkeletonLine width="55%" height="0.75rem" style={{ marginBottom: '0.6rem' }} />
        <div style={{ display: 'flex', gap: '0.3rem' }}>
          <SkeletonLine width="4rem" height="1.3rem" style={{ borderRadius: '999px' }} />
          <SkeletonLine width="4rem" height="1.3rem" style={{ borderRadius: '999px' }} />
          <SkeletonLine width="3.5rem" height="1.3rem" style={{ borderRadius: '999px' }} />
        </div>
      </div>
    </div>
  );
}

export function SkeletonPlantDetail() {
  return (
    <div className="app">
      <header className="app-header">
        <div className="app-header-brand">
          <div className="skeleton-logo-placeholder" />
          <div>
            <SkeletonHeaderLine width="7rem" height="1rem" style={{ marginBottom: '0.3rem' }} />
            <SkeletonHeaderLine width="4rem" height="0.65rem" />
          </div>
        </div>
        <div className="app-header-actions">
          <div className="skeleton-back-btn skeleton-header-line" />
        </div>
      </header>

      <div className="skeleton-hero" />

      <div className="skeleton-detail-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.6rem' }}>
          <SkeletonLine width="3rem" height="0.7rem" />
          <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
            <SkeletonLine width="2rem" height="1.8rem" style={{ borderRadius: '6px' }} />
            <SkeletonLine width="2rem" height="1.8rem" style={{ borderRadius: '6px' }} />
            <SkeletonLine width="2.5rem" height="1.8rem" style={{ borderRadius: '6px' }} />
            <SkeletonLine width="3.5rem" height="1.5rem" style={{ borderRadius: '999px' }} />
          </div>
        </div>
        <SkeletonLine width="60%" height="1.4rem" style={{ marginBottom: '0.3rem' }} />
        <SkeletonLine width="40%" height="0.9rem" />
      </div>

      <div className="skeleton-detail-body">
        <div className="skeleton-section">
          <div className="skeleton-info-grid">
            {[1, 2, 3].map(i => (
              <div key={i} className="skeleton-info-item">
                <SkeletonLine width="45%" height="0.55rem" style={{ marginBottom: '0.25rem' }} />
                <SkeletonLine width="75%" height="0.8rem" />
              </div>
            ))}
          </div>
        </div>
        {[1, 2].map(i => (
          <div key={i} className="skeleton-section">
            <SkeletonLine width="3rem" height="0.55rem" style={{ marginBottom: '0.5rem' }} />
            <div style={{ display: 'flex', gap: '0.4rem' }}>
              <SkeletonLine width="4.5rem" height="1.3rem" style={{ borderRadius: '999px' }} />
              <SkeletonLine width="5rem" height="1.3rem" style={{ borderRadius: '999px' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SkeletonActivityItem() {
  return (
    <div className="skeleton-activity-item">
      <div className="skeleton-activity-media">
        <div className="skeleton-activity-thumb skeleton-line" />
        <div className="skeleton-activity-type-icon skeleton-line" />
      </div>
      <div className="skeleton-activity-info">
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.3rem' }}>
          <SkeletonLine width="30%" height="0.75rem" />
          <SkeletonLine width="20%" height="0.75rem" />
        </div>
        <SkeletonLine width="70%" height="0.85rem" style={{ marginBottom: '0.25rem' }} />
        <SkeletonLine width="45%" height="0.7rem" />
      </div>
    </div>
  );
}

export function SkeletonActivityFeed() {
  return (
    <div className="app activity-screen">
      <header className="app-header">
        <div className="app-header-brand">
          <div className="skeleton-logo-placeholder" />
          <div>
            <SkeletonHeaderLine width="8rem" height="1rem" style={{ marginBottom: '0.3rem' }} />
            <SkeletonHeaderLine width="5rem" height="0.65rem" />
          </div>
        </div>
      </header>

      <div className="skeleton-sort-bar">
        <SkeletonLine width="3rem" height="0.75rem" />
        <SkeletonLine width="4.5rem" height="1.6rem" style={{ borderRadius: '999px' }} />
        <SkeletonLine width="5.5rem" height="1.6rem" style={{ borderRadius: '999px' }} />
      </div>

      <div className="skeleton-activity-feed">
        <SkeletonLine width="4rem" height="0.7rem" style={{ marginBottom: '0.5rem' }} />
        <SkeletonActivityItem />
        <SkeletonActivityItem />
        <SkeletonLine width="5rem" height="0.7rem" style={{ margin: '0.25rem 0 0.5rem' }} />
        <SkeletonActivityItem />
        <SkeletonActivityItem />
      </div>
    </div>
  );
}
